<template>
  <transition appear>
    <div class="base-modal" @click.self="bgClose ? close() : ''">
      <div class="base-modal__body">
        <div v-if="closeButton" class="base-modal__head">
          <img src="/static/img/icons/close.svg" alt="" class="base-modal__close" @click="close">
        </div>
        <div class="base-modal__contents">
          <slot></slot>
          <!-- 決定ボタン -->
          <base-button
            v-if="isShowConfirm"
            :label="label"
            @clicked="confirm"
          />
          <!-- キャンセルボタン -->
          <div v-if="cancel" class="base-modal__cancel" @click="close">{{ cancel }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BaseButton from './BaseButton'

export default {
  name: 'PlaylistModal',
  components: {
    BaseButton
  },
  props: {
    // ボタンのテキスト
    label: {
      type: String,
      default: 'OK'
    },
    // ボタンのリンク先
    href: {
      type: String,
      default: ''
    },
    // キャンセルボタンのテキスト
    cancel: {
      type: String,
      default: ''
    },
    // 右上の閉じるボタンの表示・非表示
    closeButton: {
      type: Boolean,
      default: false
    },
    // 背景をクリックでモーダルを閉じるか
    bgClose: {
      type: Boolean,
      default: false
    },
    // OKボタン表示・非表示
    isShowConfirm: {
      type: Boolean,
      default: true
    }
  },
  created () {
    // 背景がスクロールしない処理
    document.body.style.top = '-' + window.scrollY + 'px'
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
    document.body.style.height = 'auto'
  },
  beforeDestroy () {
    // 背景がスクロールしない処理を解除
    document.body.style.position = ''
    document.body.style.width = ''
    document.body.style.height = ''
    window.scrollTo(0, document.body.style.top.slice(1, -2))
    document.body.style.top = ''
  },
  methods: {
    /**
     * モーダルを閉じる
     */
    close () {
      this.$emit('close')
    },
    /**
     * 確定ボタンを押した
     * 親コンポーネントで `event.preventDefault()` してください
     */
    confirm () {
      this.$emit('confirm')
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.base-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 91000;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.25);
  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 327px;
    max-height: 82vh;
    background: #FFFFFF;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }
  &__head {}
  &__close {
    float: right;
    margin: 15px;
  }
  &__contents {
    color: $col_base_black;
    font-size: 13px;
    padding: 24px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  &__cancel {
    display: table;
    margin: 20px auto 0;
    padding: 5px;
    font-size: 11px;
    text-decoration: underline;
  }
}
.v-enter-active,
.v-leave-active {
  transition: all 200ms ease-out 0s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave {
  opacity: 1;
}
</style>

<style lang="scss">
.base-modal .baseButton__button {
  min-width: auto;
  width: 100%;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/PlaylistModal.vue